module.exports = __webpack_public_path__ + "img/arrow_up_2.42991a9f.svg";